<template>
  <div class="t-container page">
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Users
      </h1>
      <div class="t-flex t-mx-auto t-my-2">
        <button
          @click="showForm()"
          class="t-align-right t-bg-dodger-blue t-px-8 t-py-3"
        >
          <span class="t-text-base t-font-bold t-text-white">
            <span class="t-text-sm">+</span>
            Add User
          </span>
        </button>
      </div>
    </div>

    <div class="t-mt-12 t-flex t-justify-center">
      <loading-alert v-if="loading" text="Fetching users"></loading-alert>
      <table
        class="t-w-full t-text-md bg-white t-shadow-md t-rounded t-mb-4"
        v-else
      >
        <tbody>
          <tr class="t-border-b">
            <th class="t-text-left t-p-3 t-px-5">Name</th>
            <th class="t-text-left t-p-3 t-px-5">Email</th>
            <th class="t-text-left t-p-3 t-px-5">Mobile</th>
            <th class="t-p-3 t-px-5 t-flex t-justify-start">Actions</th>
          </tr>
          <tr
            class="t-border-b hover:t-bg-orange-100 t-bg-gray-100"
            v-for="(user, index) in users"
            :key="user.id"
          >
            <td class="t-p-3 t-px-5">
              {{ user.name }}
            </td>
            <td class="t-p-3 t-px-5">
              {{ user.email }}
            </td>
            <td class="t-p-3 t-px-5">
              {{ user.mobile_number }}
            </td>
            <td class="t-p-3 t-px-5 t-flex t-justify-start">
              <button
                @click="updateUser(user)"
                class="t-mr-3 t-text-sm t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-py-1 t-px-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
              >
                Edit <i class="fa fa-pencil"></i>
              </button>
              <button
                v-if="user.id != loggedInUserId"
                @click="deleteUser(user)"
                class="t-text-sm t-bg-red-500 hover:t-bg-red-700 t-text-white t-py-1 t-px-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
              >
                Delete <i class="fa fa-trash"></i>
              </button>
              <div>
                <button
                  v-if="scanners[index].user_id != user.id"
                  @click="invite(user)"
                  class="t-text-sm t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-py-1 t-px-2 t-mx-3 t-rounded focus:t-outline-none focus:t-shadow-outline"
                >
                  Invite to CodeREADr <i class="fa fa-user-plus"></i>
                </button>
                <div v-else>
                  <button
                    @click="$set(user, 'shown', true)"
                    v-show="!user.shown"
                    class="t-text-sm t-bg-green-500 hover:t-bg-green-700 t-text-white t-py-1 t-px-2 t-mx-3 t-rounded focus:t-outline-none focus:t-shadow-outline"
                  >
                    Click for login info <i class="fa fa-check"></i>
                  </button>
                  <button
                    @click="$set(user, 'shown', false)"
                    v-show="user.shown"
                    class="t-text-sm t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-py-1 t-px-2 t-mx-3 t-rounded focus:t-outline-none focus:t-shadow-outline"
                  >
                    Username: {{ scanners[index].username }} Password:
                    {{ scanners[index].pin }}
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <business-users-form
      v-if="formShowing"
      :showing="formShowing"
      :user="updatingUser"
      @cancelled="formCancelled()"
      @submitted="formSubmitted()"
    >
    </business-users-form>

    <confirm-modal
      v-if="modalShowing"
      :showing="modalShowing"
      :confirming="confirming"
      title="Confirm delete?"
      text="Are you sure you want to delete this user from your business?"
      @confirmed="deleteConfirmed()"
      @cancelled="deleteCancelled()"
    >
    </confirm-modal>
  </div>
</template>

<script type="text/babel">
import BusinessUsersForm from "./BusinessUsersForm";

export default {
  name: "business-users",
  components: {
    BusinessUsersForm
  },
  props: ["business"],
  data() {
    return {
      loggedInUserId: window.Freighthub.user.id,
      loading: true,
      users: [],
      modalShowing: false,
      confirming: false,
      formShowing: false,
      updateFormShowing: false,
      updatingUser: null,
      scanners: []
    };
  },
  created() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      this.loading = true;
      axios.get("/settings/business/users").then(response => {
        this.loading = false;
        this.users = response.data.data.users.data;
        this.scanners = response.data.data.scanners.data;
      });
    },

    deleteUser(user) {
      this.modalShowing = true;
      this.deletingUser = user;
    },

    deleteConfirmed() {
      this.confirming = true;
      axios
        .delete("/settings/business/users/" + this.deletingUser.id)
        .then(response => {
          this.modalShowing = false;
          this.confirming = false;
          this.$swal({
            title: this.deletingUser.name + " removed from business!",
            type: "success",
            confirmButtonText: "Okay"
          });
          this.deletingUser = null;
          this.loadUsers();
        });
    },

    deleteCancelled() {
      this.modalShowing = false;
      this.deletingUser = null;
    },

    showForm() {
      this.formShowing = true;
    },

    updateUser(user) {
      this.updatingUser = user;
      this.formShowing = true;
    },

    formCancelled() {
      this.formShowing = false;
      this.updatingUser = null;
    },

    formSubmitted() {
      this.formShowing = false;
      this.loadUsers();
    },

    invite(user) {
      if (user.mobile_number != "" && user.mobile_number) {
        axios
          .post("/settings/business/users/codeReadr/" + user.id)
          .then(response => {
            this.$swal({
              title:
                user.name +
                "  has been sent an invitation by text! Please wait as it may take a minute to arrive.",
              type: "success",
              confirmButtonText: "Okay"
            });
          });
      } else {
        this.$swal({
          title: "Whoops!",
          text:
            "The user needs to have a mobile phone number, please enter one.",
          type: "error",
          confirmButtonText: "Okay"
        });
      }
    }
  }
};
</script>
